import React, { useEffect, useState } from "react";

import { T } from "services/lang/LanguageService";
import { useUpdateDatasetGroup } from "api/api-hooks/dataset-groups-hooks";
import { GroupButtonProps } from "api/model/dataset/datasetGroups";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import TitleForm from "./TitleForm";

const RenameGroupButton: React.FC<GroupButtonProps> = ({ group }) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("");
  const { mutateAsync } = useUpdateDatasetGroup();

  useEffect(() => {
    if (group) setTitle(group.title);
  }, [group]);

  const updateGroup = async () => {
    await mutateAsync({ ...group!, title });
    setDialogOpen(false);
  };

  return (
    <>
      <Dialog visible={dialogOpen} onHide={() => setDialogOpen(false)} header={T("action.rename-group")}>
        <TitleForm
          title={title}
          setTitle={setTitle}
          buttonLabel={T("action.rename")}
          buttonColor="warning"
          onCancel={() => setDialogOpen(false)}
          onAccept={updateGroup}
        />
      </Dialog>
      <Button
        label={T("action.rename-group")}
        icon="pi pi-pencil"
        onClick={() => setDialogOpen(true)}
        className="component-editor-button icon-yellow"
        disabled={!group}
      />
    </>
  );
};

export default RenameGroupButton;
